module.exports = __webpack_public_path__ + "img/Weapon_141.3b4a6eca.png";